import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

export default function OperatingExpenseIcon(props: Props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#EEE9FF" />
      <rect
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_1751_3314)"
      />
      <path
        d="M27.3475 17.8565C26.9508 17.4951 26.4434 17.3098 25.9013 17.3351C25.3653 17.3598 24.8712 17.5925 24.5111 17.9892L22.3662 20.3462C21.9988 19.7395 21.3327 19.3334 20.5732 19.3334H14.667C13.1962 19.3334 12 20.5296 12 22.0005V25.3343C12 26.8052 13.1962 28.0013 14.667 28.0013H17.9775C19.8771 28.0013 21.6914 27.1879 22.9562 25.769L27.4929 20.6769C28.2223 19.8595 28.157 18.5946 27.3475 17.8565ZM26.4974 19.7895L21.9608 24.8822C20.9486 26.0164 19.4971 26.6678 17.9775 26.6678H14.667C13.9316 26.6678 13.3335 26.0697 13.3335 25.3343V22.0005C13.3335 21.265 13.9316 20.6669 14.667 20.6669H20.5732C20.9926 20.6669 21.3347 21.009 21.3347 21.429C21.3347 21.8051 21.054 22.1298 20.6812 22.1825L17.2401 22.6739C16.876 22.7259 16.6227 23.0639 16.6747 23.4287C16.7267 23.7941 17.0661 24.0474 17.4288 23.9947L20.8699 23.5033C21.6534 23.3913 22.2895 22.8452 22.5462 22.1311L25.4979 18.8873C25.6186 18.754 25.7846 18.6766 25.964 18.668C26.1454 18.6626 26.3167 18.7227 26.4494 18.8427C26.7208 19.0907 26.7428 19.5154 26.4974 19.7901V19.7895ZM21.5307 14.8614C21.27 14.6007 21.27 14.1793 21.5307 13.9186L23.0596 12.3897C23.3083 12.1404 23.669 11.999 24.0024 11.999C24.3358 11.999 24.6965 12.1404 24.9452 12.3897L26.4741 13.9186C26.7348 14.1793 26.7348 14.6007 26.4741 14.8614C26.3441 14.9915 26.1734 15.0568 26.0027 15.0568C25.832 15.0568 25.6613 14.9915 25.5313 14.8614L24.6692 13.9993V15.9996C24.6692 16.3677 24.3711 16.6664 24.0024 16.6664C23.6337 16.6664 23.3356 16.3677 23.3356 15.9996V13.9993L22.4735 14.8614C22.2128 15.1221 21.7914 15.1221 21.5307 14.8614ZM16.5013 17.9999H18.835C19.8465 17.9999 20.6686 17.1264 20.6686 16.0536C20.6686 14.9434 19.6144 13.7379 18.5763 13.2379C18.6856 13.1285 18.791 13.0098 18.8843 12.8838C19.1544 12.5171 18.9057 11.9997 18.4503 11.9997H16.8854C16.4546 11.9997 16.1739 12.4864 16.422 12.8391C16.5226 12.9818 16.64 13.1159 16.762 13.2379C15.7232 13.7379 14.6684 14.9441 14.6684 16.0543C14.6684 17.1278 15.4905 18.0006 16.502 18.0006L16.5013 17.9999ZM17.6681 14.3327C18.1649 14.3327 19.3351 15.3508 19.3351 16.0536C19.3351 16.3917 19.111 16.6664 18.835 16.6664H16.5013C16.2253 16.6664 16.0012 16.391 16.0012 16.0536C16.0012 15.3508 17.1714 14.3327 17.6681 14.3327Z"
        fill="#784EFF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1751_3314"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBA7FF" />
          <stop offset="1" stop-color="#BBA7FF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
